import 'katex/dist/katex.min.css';
import { FC, useState } from "react";

//!COMPONENTS

//!ANTD

//!STYLES
import s from "./assets/footerFooter.module.css";

//!IMAGES
import Container from "components/container";
import albert_head from "../../../../assets/images/albert/status/Very happy.svg";
import icon_facebook from "./assets/images/icon_facebook.svg";
import icon_instagram from "./assets/images/icon_instagram.svg";
import icon_linkedin from "./assets/images/icon_linkedin.svg";
import icon_youtube from "./assets/images/icon_youtube.svg";

import { useSelector } from "react-redux";

const FooterFooter: FC = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1051);
  const handleResize = () => {
    setIsMobile(window.innerWidth < 1051);
  };
  window.addEventListener('resize', handleResize);

  const { isLoggedIn, user } = useSelector((state) => state.auth);

  return (
    <div className={s.footerFooter}>
      {isMobile ? <div className={s.footerBox}>
        <div className={s.footerBoxTop}>
          <div className={s.footerBoxTopMain}>
            <div className={s.logoContainer}>
              {!isMobile && <div className={s.logoBox}>
                <img src={albert_head} style={{ height: "60px" }}></img>
              </div>}
              <a className={s.logoTitle}>MON AMI<br />ALBERT</a>
            </div>
            <p className={s.footerMessage}>La réussite et l’excellence académiques<br /> à portée de tous!</p>
            <p className={s.followUsTitle}>Suivez-nous</p>
            <div className={s.socialBox}>
              <img src={icon_facebook} style={{ height: "21px", marginRight: "30px" }}></img>
              <img src={icon_instagram} style={{ height: "21px", marginRight: "30px" }}></img>
              <img src={icon_linkedin} style={{ height: "21px", marginRight: "30px" }}></img>
              <img src={icon_youtube} style={{ height: "21px" }}></img>
            </div>
          </div>
          <div className={s.footerBoxTopMain}>
            <p className={s.menuTitle}>Explorer</p>
            {isMobile ? <div className={s.menuBox}>
              <div style={{ display: "flex", flexDirection: "column", marginRight: "40px" }}>
                {/* <a href="#" style={{ color: "rgb(204, 204, 204)" }}>Qui Suis-je ?</a> */}
                <a href="/parent" style={{ color: "rgb(204, 204, 204)" }}>Parent</a>
                <a href="/teacher" style={{ color: "rgb(204, 204, 204)" }}>Enseignant</a>
              </div>
              {/* <div style={{ display: "flex", flexDirection: "column", marginRight: "40px" }}>
                <a href="/teacher" style={{ color: "rgb(204, 204, 204)" }}>Enseignant</a>
                <a href="#" style={{ color: "rgb(204, 204, 204)" }}>Méthodologie</a>
              </div> */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <a href="/contact" style={{ color: "rgb(204, 204, 204)" }}>Contact</a>
                <a href="/faq" style={{ color: "rgb(204, 204, 204)" }}>Aide</a>
              </div>
            </div> : <div className={s.menuBox}>
              {/* <a href="#" style={{ color: "rgb(204, 204, 204)" }}>QUI SUIS-JE ?</a> */}
              <a href="/parent" style={{ color: "rgb(204, 204, 204)" }}>PARENT</a>
              <a href="/teacher" style={{ color: "rgb(204, 204, 204)" }}>ENSEIGNANT</a>
              {/* <a href="#" style={{ color: "rgb(204, 204, 204)" }}>MÉTHODOLOGIE</a> */}
              <a href="/contact" style={{ color: "rgb(204, 204, 204)" }}>CONTACT</a>
              <a href="/faq" style={{ color: "rgb(204, 204, 204)" }}>AIDE</a>
            </div>}
          </div>
          <div className={s.footerBoxTopMain}>
            <p className={s.menuTitle}>Newsletter</p>
            <p className={s.footerMessage}>Inscrivez-vous à notre newsletter<br />pour découvrir des astuces pédagogiques,<br />accéder à des ressources exclusives,<br />suivre nos consignes et rester<br />informé des dernières nouveautés.</p>
            <div className={s.formBox}>
              <form className={s.newslettersForm}>
                <input className={s.newslettersFormEmail} type="email" id="newsletterEmail" name="newsletterEmail" placeholder="Entrez votre email ici" required></input>
                <button type="submit" className={s.newslettersButton}>Je m’inscris</button>
              </form>
            </div>
          </div>
        </div>
        <div className={s.footerBoxBottom}>
          <div className={s.footerSeparator}></div>
          <div className={s.footerBottomBox}>
            <a className={s.footerCopyrights}>Ⓒ Mon ami Albert 2024  </a>
            <div className={s.copyrightsSeparator}></div>
            <a className={s.legalMention} href="/assets/files/mentions-legales.pdf" target="_blank" rel="noopener noreferrer"> Mentions légales</a>
          </div>
        </div>
      </div> : <Container>
        <div className={s.footerBox}>
          <div className={s.footerBoxTop}>
            <div className={s.footerBoxTopMain}>
              <div className={s.logoContainer}>
                {!isMobile && <div className={s.logoBox}>
                  <img src={albert_head} style={{ height: "60px" }}></img>
                </div>}
                <a className={s.logoTitle}>MON AMI<br />ALBERT</a>
              </div>
              <p className={s.footerMessage}>La réussite et l’excellence académiques<br /> à portée de tous!</p>
              <p className={s.followUsTitle}>Suivez-nous</p>
              <div className={s.socialBox}>
                <img src={icon_facebook} style={{ height: "21px", marginRight: "30px" }}></img>
                <img src={icon_instagram} style={{ height: "21px", marginRight: "30px" }}></img>
                <img src={icon_linkedin} style={{ height: "21px", marginRight: "30px" }}></img>
                <img src={icon_youtube} style={{ height: "21px" }}></img>
              </div>
            </div>
            <div className={s.footerBoxTopMain}>
              <p className={s.menuTitle}>Explorer</p>
              {isMobile ? <div className={s.menuBox}>
                <div style={{ display: "flex", flexDirection: "column", marginRight: "40px" }}>
                  {/* <a href="#" style={{ color: "rgb(204, 204, 204)" }}>Qui Suis-je ?</a> */}
                  <a href="/parent" style={{ color: "rgb(204, 204, 204)" }}>Parent</a>
                  <a href="/teacher" style={{ color: "rgb(204, 204, 204)" }}>Enseignant</a>
                </div>
                {/* <div style={{ display: "flex", flexDirection: "column", marginRight: "40px" }}>
                  <a href="/teacher" style={{ color: "rgb(204, 204, 204)" }}>Enseignant</a>
                  <a href="#" style={{ color: "rgb(204, 204, 204)" }}>Méthodologie</a>
                </div> */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <a href="/contact" style={{ color: "rgb(204, 204, 204)" }}>Contact</a>
                  <a href="/faq" style={{ color: "rgb(204, 204, 204)" }}>Aide</a>
                </div>
              </div> : <div className={s.menuBox}>
                {/* <a href="#" style={{ color: "rgb(204, 204, 204)" }}>QUI SUIS-JE ?</a> */}
                <a href="/parent" style={{ color: "rgb(204, 204, 204)" }}>PARENT</a>
                <a href="/teacher" style={{ color: "rgb(204, 204, 204)" }}>ENSEIGNANT</a>
                {/*  <a href="#" style={{ color: "rgb(204, 204, 204)" }}>MÉTHODOLOGIE</a> */}
                <a href="/contact" style={{ color: "rgb(204, 204, 204)" }}>CONTACT</a>
                <a href="/faq" style={{ color: "rgb(204, 204, 204)" }}>AIDE</a>
              </div>}
            </div>
            <div className={s.footerBoxTopMain}>
              <p className={s.menuTitle}>Newsletter</p>
              <p className={s.footerMessage}>Inscrivez-vous à notre newsletter<br />pour découvrir des astuces pédagogiques,<br />accéder à des ressources exclusives,<br />suivre nos consignes et rester<br />informé des dernières nouveautés.</p>
              <div className={s.formBox}>
                <form className={s.newslettersForm}>
                  <input className={s.newslettersFormEmail} type="email" id="newsletterEmail" name="newsletterEmail" placeholder="Entrez votre email ici" required></input>
                  <button type="submit" className={s.newslettersButton}>Je m’inscris</button>
                </form>
              </div>
            </div>
          </div>
          <div className={s.footerBoxBottom}>
            <div className={s.footerSeparator}></div>
            <div className={s.footerBottomBox}>
              <a className={s.footerCopyrights}>Ⓒ Mon ami Albert 2024  </a>
              <div className={s.copyrightsSeparator}></div>
              <a className={s.legalMention} href="/assets/files/mentions-legales.pdf" target="_blank" rel="noopener noreferrer"> Mentions légales</a>
            </div>
          </div>
        </div>
      </Container>}
    </div>
  );
};

export default FooterFooter;
